import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X, Check } from "lucide-react";
import { toast } from "sonner";
import { useApp } from "@/store/AppContext";
import { Button } from "@/components/ui-kit";

export const QuickCapture: React.FC<{ open: boolean; onClose: () => void }> = ({
  open,
  onClose,
}) => {
  const { addCapture } = useApp();
  const [text, setText] = useState("");

  const save = () => {
    if (!text.trim()) return;
    addCapture(text);
    setText("");
    onClose();
    toast.success("Noté. Tu pourras le trier plus tard.");
  };

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-[60] flex items-end justify-center"
          data-testid="quick-capture-modal"
        >
          <div
            className="absolute inset-0 bg-forest-900/25 backdrop-blur-md"
            onClick={onClose}
          />
          <motion.div
            initial={{ y: 60, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: 60, opacity: 0 }}
            transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
            className="relative w-full max-w-md bg-cream rounded-t-[2rem] p-6 pb-8 shadow-2xl"
          >
            <div className="flex items-center justify-between mb-5">
              <p className="text-xs uppercase tracking-[0.2em] font-medium text-forest-500">
                Capture rapide
              </p>
              <button
                onClick={onClose}
                data-testid="capture-close"
                className="p-2 -mr-2 rounded-full text-forest-500 hover:bg-forest-900/5"
                aria-label="Fermer"
              >
                <X strokeWidth={1.75} className="h-5 w-5" />
              </button>
            </div>

            <h2 className="font-heading text-2xl font-light tracking-tight text-forest-900 mb-5">
              Qu'as-tu en tête&nbsp;?
            </h2>

            <textarea
              autoFocus
              value={text}
              onChange={(e) => setText(e.target.value)}
              onKeyDown={(e) => {
                if ((e.metaKey || e.ctrlKey) && e.key === "Enter") save();
              }}
              data-testid="capture-input"
              placeholder="Une idée, une tâche, une pensée…"
              className="w-full bg-white border border-forest-900/10 rounded-2xl px-5 py-4 text-forest-900 placeholder:text-forest-500/60 focus:outline-none focus:ring-2 focus:ring-sage/40 min-h-[120px] resize-none leading-relaxed"
            />

            <Button full onClick={save} data-testid="capture-save" className="mt-5">
              <Check strokeWidth={2} className="h-5 w-5" />
              Déposer dans l'inbox
            </Button>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
